import { Link } from '@routes'
import { Section } from '@styles/global.styled'
import Button from '@global/Button'
import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'

const PropertyAlertLanding = ({ pageData }) => {
  return (
    <>
      <WagtailBlocksSection blocks={pageData.content_blocks} />
      <Section>
        <Link route={pageData.call_to_action_link} passHref>
          <Button color='secondary'>{pageData.call_to_action_label}</Button>
        </Link>
      </Section>
    </>
  )
}

export default PropertyAlertLanding
